module.exports = __webpack_public_path__ + "c2b729d671482dec082145f7e2e6139d.png";